import React, {useEffect, useState, useRef, useCallback} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    // InfoBox, 
    InfoWindow, 
    Marker, 
    // Polygon,
} from '@react-google-maps/api';
import _ from 'lodash';
// import moment from 'moment';

import MapView from '../../components/MapView';
import HideablePanel from '../../components/HideablePanel';
import ToolbarMenu from '../../components/Common/ToolbarMenu';
import BatchInfo from '../../components/MapManagement/BatchInfo';
import HideablePanelHeader from '../../components/HideablePanel/HideablePanelHeader';
import DriverSearch from '../../components/MapManagement/DriverSearch';
import AccountList from '../../components/MapManagement/AccountList';
import BbcOrderManagement from '../../components/BbcOrderManagement';
import { useDispatch, useSelector } from 'react-redux';
import {
    getOrderMarkerVisibility,
    setRouteStartPoint, setRouteEndPoint,
    getRoutePlanner,
    showOrderMarkerVisibility,
    resetOrderMarker,
    removeMarker,
    getMarkerSelectionMode, setMarkerSelectionMode,
} from '../../reducers/mapMarkerSlice';
import {
    assignOrderToDriver,
    createDispatchHistory,
    getDistricts,
    getDriverOrderCount,
    getDriverOrders,
    getDriverOrdersByShippingStatus,
    getStaffList,
} from '../../actions/mmActions';
import SelectBatchModal from '../../components/MapManagement/SelectBatchModal';
import EditOrderModal from '../../components/EditOrderModal';
import EditDriverModal from '../../components/EditDriverModal';
import ParcelReturnModal from '../../components/ParcelReturnModal';
import StorageScan from '../../components/StorageScanManagement';
import SecondDelivery from '../../components/SecondDelivery';
import HelpDesk from '../../components/HelpDesk';
import UpdateToolbox from '../../components/UpdateToolbox';
import EtaDeliveryRateReport from '../../components/EtaDeliveryRateReport';
import ComplaintModal from '../../components/ComplaintModal';
import SelfReturn from '../../components/SelfReturn';
import HoldingPackagesManagement from '../../components/HoldingPackagesManagement';
import DriverDispatch from '../../components/DriverDispatch';
import ScanReport from '../../components/ScanReport';
import ListError from '../../components/Common/ListError';
import FullscreenLoading from '../../components/Common/FullscreenLoading';
import {
    flattenOrders,
    getAccountFilteredDistricts,
    getCheckedOrders,
    getDriverOrderTrackingStatus,
    getRoutePrefix,
    getUserPreference,
    handleTextualizeDriverNameAndVehicleType,
    stripIdFromStaffName,
} from '../../utilities/common';
import { getBranchList } from '../../actions/commonAction';
import {
    handleRouteToolbar, getOpenRouteToolbar,
    getSelectedBatchIds,
    getOpenTransferOrdersDialog, handleTransferOrdersDialog,
    showAlertSnackbar,
    handleDriveNotePrefixDialog, getOpenDriveNotePrefixDialog,
    getSelectedOrders, getSelectedAccounts,
    resetSelectedOrders, resetSelectedAccounts,
    setSelectedOrders,
    getOpenSaveDispatchHistoryDialog, handleSaveDispatchHistoryDialog,
    getOrderFilterDialog, handleOrderFilterDialog,
    getOrderFilterTargetDriverId,
    getOpenDriverListDialog,
    scrollToOrderId,
    getOpenProblemOrderDialog,
    getOpenDestinationEditDialog, handleOpenDestinationEditDialog,
    getEditOrder,
    getProblematicOrders,
    getOpenPostalCodesExportToolbar,
    getBatchSelectionConfig,
} from '../../reducers/uiSlice';
import { MapModes } from '../../constants/general';
import { getRoutePlanners, getRoutePreview, getRoutePreviewVRP, resetRoutePreview, saveRoutes } from '../../actions/rmActions';
import UniDialog from '../../components/Common/UniDialog';
import { Badge, Checkbox, FormControl, FormControlLabel, MenuItem, Paper, Radio, RadioGroup, TextField, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import OrderFilter from '../../components/MapManagement/SelectableOrderInfo/OrderFilter';
import { changeParcelStatusFilter, getOrderFilter, resetOrderFilter } from '../../reducers/filterSlice';
import RouteToolbarModal from '../../components/Modals/RouteToolbarModal';
import { LoadDispatchHistoryModal } from '../../components/Modals/DispatchHistoryModal';
import OrderSelectCounter from '../../components/MapManagement/OrdersSelectCounter';
import MapToolBar from '../../components/MapView/mapToolbar';
import QuickTransfer from '../../components/QuickTransfer';
import TransferOrdersSubBatch from '../../components/TransferOrdersSubBatch';
import { batchChange, refreshExistOrders } from '../../network/mmHelper';
import { grey } from '@material-ui/core/colors';
import ProblematicOrderList from '../../components/MapManagement/ProblematicOrderList';
import DestinationEditModal from '../../components/Modals/DestinationEditModal';
import UploadExcelModal from '../../components/UploadExcelModal';
import update from 'immutability-helper';
import AdvancedSearchModal from '../../components/Modals/AdvancedSearchModal';
import { getLetianStaff } from '../../actions/ddActions';
import LastStateStatistics from '../../components/LastStateStatistics';
import WorkflowModal from '../../components/Modals/WorkflowModal';
import { getLetianStaffTemp } from '../../actions/qtActions';
import UserManagement from '../../components/UserManagement';
import SettingsModal from '../../components/Modals/SettingsModal';
import { mainMenuItems } from '../../components/Common/ToolbarMenu/mainMenu';
import { toolMenuItems } from '../../components/Common/ToolbarMenu/toolMenu';
import PostalCodesExportToolbar from '../../components/PostalCodesExportToolbar';
import LocalDeliveryCountReport from '../../components/LocalDeliveryCountReport';
import { Autocomplete } from '@material-ui/lab';
import { assignServicePoint, getDriverServicePoint, getServicePoint } from '../../actions/dropOffActions';
import PreAlertQuery from '../../components/PreAlertQuery';
import { useToken } from '../../utilities/hooks';
import { changeLanguagePref } from '../../utilities/language';
import DriverPickup from '../../components/DriverPickup';
import PodQualityManagement from '../../components/PodQualityManagement';
import UserAuthUpdate from '../../components/Common/UserAuthUpdate';
import { managementMenuItems } from '../../components/Common/ToolbarMenu/managementMenu';
import * as rmHelper from '../../network/rmHelper';
import MessageCenter from '../../components/MessageCenter';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme)=> ({
    root: {
        scrollbarGutter: 'stable',
        overflow: 'hidden'
    },
    leftPanel: {
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        maxheight: '100%',
        // width: '350px',
        zIndex: theme.zIndex.drawer,
    },
    rightPanel: {
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        maxheight: '100%',
        // width: '550px',
        zIndex: theme.zIndex.drawer,
    },
    label: {
        flexDirection: 'column'
    },
    routePlanner: {
        transform: 'translate(0, 40vh)'
    },
    mapInfoWindow: {
        //backgroundColor: theme.palette.background.default
    },
    driverStyle: {
        marginTop: 20,
        padding: '10 5'
    },
    titleStyle: {
        marginBottom: 10
    },
    margin: {
        margin: theme.spacing.unit * 2
    },
}))

const checkBoxStyle = makeStyles((theme)=> ({
    root: {
        color: grey[500],
        '&$checked': {
            color: theme.palette.secondary,
          }
    },
    checked: {}
}))

const workTabs = [
    {label: "A", value: 0},
    {label: "B", value: 1},
    {label: "Driver On", value: 2},
    {label: "Driver Off", value: 3}
]

const menuTabs=[
    {label: "Menu", value: 0, config: mainMenuItems},
    {label: "Tools", value: 1, config: toolMenuItems},
    {label: "Mgmt.", value: 2, config: managementMenuItems}
]

function Main() {
    const classes = useStyles();
    const checkBoxClasses = checkBoxStyle();
    const {t, i18n} = useTranslation('mapManagement');
    const tokenContents = useToken();
    const history = useHistory();
    const userRoles = tokenContents.roles;

    let userUS = tokenContents.userUS;
    let userPref = getUserPreference();
    //let markers = useSelector(getOrderMarkers);
    let orderMarkerVisibility = useSelector(getOrderMarkerVisibility);
    let openRouteToolbar = useSelector(getOpenRouteToolbar);
    let selectedOrders = useSelector(getSelectedOrders);
    let selectedAccounts = useSelector(getSelectedAccounts);
    let routePlanner = useSelector(getRoutePlanner);
    let selectedBatchIds = useSelector(getSelectedBatchIds);
    let openTransferOrdersDialog = useSelector(getOpenTransferOrdersDialog);
    let openDriveNotePrefixDialog = useSelector(getOpenDriveNotePrefixDialog);
    let openSaveDispatchHistoryDialog = useSelector(getOpenSaveDispatchHistoryDialog);
    let openOrderFilterDialog = useSelector(getOrderFilterDialog);
    let orderFilterTargetDriverId = useSelector(getOrderFilterTargetDriverId);
    let orderFilters = useSelector(getOrderFilter);
    let openDriverListDialog = useSelector(getOpenDriverListDialog);
    let markerSelectionMode = useSelector(getMarkerSelectionMode);
    let openProblemOrderDialog = useSelector(getOpenProblemOrderDialog);
    let openDestinationEditDialog = useSelector(getOpenDestinationEditDialog);
    let batchSelectionConfig = useSelector(getBatchSelectionConfig);
    const filterChange = useSelector(state => state.mapManagement.filterChange);
    
    let editOrder = useSelector(getEditOrder);
    const problemOrders = useSelector(getProblematicOrders);

    const openPostalCodesToolbar = useSelector(getOpenPostalCodesExportToolbar);
    const currentDriverId = useSelector(state=>state.mapManagement.driverId);

    const dispatch = useDispatch();
    const mapManagement = useSelector(state => state.mapManagement);
    const routeManagement = useSelector(state => state.routeManagement);
    const quickTransfer = useSelector(state => state.quickTransfer)
    const servicePointListCurr = useSelector(state => state.servicePoint.getServicePoint);
    const routeType = useSelector(state=>state.mapManagement.routeType);

    const [mapMode, setMapMode] = useState(MapModes.SELECT_MARKER);
    const [mapDefaultCenter, setMapDefaultCenter] = useState();
    const [routePrefix, setRoutePrefix] = useState("");
    const [transferToId, setTransferToId] = useState("");
    const [checkedOrders, setCheckedOrders] = useState([])
    const [dispatchHistoryName, setDispatchHistoryName] = useState("")
    const [accountSearchKeyword, setAccountSearchKeyword] = useState("")
    const [mapOrderSelection, setMapOrderSelection] = useState([])
    const [orderMarkers, setOrderMarkers] = useState({normal: [], sameAddress: []})
    const [openInfoWindow, setOpenInfoWindow] = useState()
    const [transferDriverName, setTransferDriverName] = useState('...');
    const [driverExist, setDriverExist] = useState(false);
    const [driverListTemp, setDriverListTemp] = useState([]);
    const [searchList, setSearchList] = useState([]);
    const [enableExport, setEnableExport] = useState(false);
    const [overlayEvent, setOverlayEvent] = useState();
    const [enableCircle, setEnableCircle] = useState(false);

    const [overlayType, setOverlayType] = useState(1);
    const [bounds, setBounds] = useState([]);
    const [oPoint, setOPoint] = useState([]);
    const [radius, setRadius] = useState();

    const [selectedWeight, setSelectedWeight] = useState(0);

    const [weightFilterTotal, setWeightFilterTotal] = useState();
    const [reset, setReset] = useState(false);
  
    const [servicePointList, setServicePointList] = useState([]);
    const [servicePointId, setServicePointId] = useState('');
    const [lastDropOff, setLastDropOff] = useState('');
    const [servicePointViewOpen, setServicePointViewOpen] = useState(false);
    const [accountListDropOff, setAccountListDropOff] = useState('');
    const [shippingStatusNum, setShippingStatusNum] = useState(0);
    const [shippingStatusNum0, setShippingStatusNum0] = useState(0);

    const [routeList, setRouteList] = useState([]);
    const [routeId, setRouteId] = useState('');
    const [transferType, setTransferType] = useState('0');
    const [routeInfo, setRouteInfo] = useState({});
    const [selectedRoute, setSelectedRoute] = useState({})

    const delaySearch = useCallback(_.debounce(value=>setAccountSearchKeyword(value), 350), [])
    const rightPanelDisable = rightPanelLock()
    const unmodifiedOrderMarker = useRef(null)

    useEffect(() => {
        if (userRoles.includes("Pickup Only") && userRoles?.length === 1) {
            console.log(userRoles)
            history.push('/self-pickup-tool');
        }
    }, [])

    useEffect(() => {
        setServicePointId('');
        if(userPref.userCity == null){
            console.error("[FATAL] City ID Missing!")
            dispatch(showAlertSnackbar({
                title: "[FATAL] City ID Missing!", 
                message: "Please contact administrator to sort out this problem! If it's resolved please login again!",
                duration: 15000
            }))
        }
        dispatch(getDistricts())
        dispatch(getBranchList()).then((res) => {
            // eslint-disable-next-line no-throw-literal
            if (res === null) throw "Branch list null";

            window.localStorage.setItem('branches', JSON.stringify(res));

            let currentBranch = res.find(x => x.id === userPref.userCity);
            setMapDefaultCenter({
                lat: currentBranch.lat ?? res[0].lat,
                lng: currentBranch.lng ?? res[0].lng,
            });
        }).catch(_ => {
            setMapDefaultCenter({
                //Vancouver
                lat: 49.1671284, 
                lng: -122.9868912,
            });
        });

        if(mapManagement.staff.length <= 0){
            dispatch(getStaffList(userPref.userCity, 1))
        }

        dispatch(getLetianStaff(userPref.userCity))
        .then((res) => {
            setSearchList(res)
        })
        if(userPref.userCity === 2) {
            dispatch(getLetianStaffTemp(14))
            .then((res) => {
                setDriverListTemp(res);
            })
        }
        if(userPref.userCity === 14) {
            dispatch(getLetianStaffTemp(2))
            .then((res) => {
                setDriverListTemp(res);
            })
        }
    }, [])

    useEffect(()=>{
        if(selectedOrders) {
            if(selectedOrders.length > 0) {
                if(
                    typeof selectedOrders[0] === 'object' && 
                    !Array.isArray(selectedOrders[0]) && 
                    selectedOrders[0] !== null
                ) {
                    let currentOrderIds = _.map(selectedOrders, 'order_id');
                    let originalOrders = [];
                    if(mapManagement.ordersByDriver[currentDriverId]) {
                        originalOrders = mapManagement.ordersByDriver[currentDriverId][0]
                    }
                    for(var orderIndex in selectedOrders) {
                        let index = originalOrders?.findIndex((obj=>obj.order_id === selectedOrders[orderIndex].order_id));
                        if(index >= 0) {
                            originalOrders[index].pack_id = selectedOrders[orderIndex].pack_id;
                        }
                    }
                    packIdStrModify(generateOrderMapMarker(mapManagement.ordersByDriver, currentOrderIds));
                    return;
                }
            }
        }
        packIdStrModify(generateOrderMapMarker(mapManagement.ordersByDriver, selectedOrders))
    }, [selectedOrders])

    useEffect(()=>{
        if(mapOrderSelection.length <= 0){
            dispatch(scrollToOrderId(null))
        }
        if(mapOrderSelection) {
            if(mapManagement.ordersByDriver && mapOrderSelection.length > 0) {
                let weight = 0;
                let driverOrdersObject = Object.values(mapManagement.ordersByDriver)[0];
                let driverOrders = Object.values(driverOrdersObject);
                driverOrders.map((orders) => {
                    orders.map((order) => {
                        mapOrderSelection.map((selected) => {
                            if(order.order_id === selected) {
                                weight += Number(order.total_weight);
                            }
                        })
                    })
                })
                setSelectedWeight(weight);
            }
        }
    }, [mapOrderSelection])

    useEffect(()=>{
        if(openInfoWindow !== null){
            if(_.indexOf(selectedOrders, openInfoWindow)){
                setOpenInfoWindow(null)
            }
        }
    }, [selectedOrders])

    useEffect(() => {
        if(reset) {
            dispatch(getDriverOrderCount(userPref.userCity, selectedBatchIds, userPref.hideAssociatedOrders, userPref.hideSubReferrer))
        }
    }, [reset])

    useEffect(() => {
        dispatch(getServicePoint(userPref.userCity))
        // US-BRANCH-OFF
        if(userUS) {
            if(i18n.language.includes('en')) {
                changeLanguagePref(i18n, 'en-US')
            } else if(i18n.language.includes('zh')) {
                changeLanguagePref(i18n, 'zh-US')
            }
        } else {
            if(i18n.language.includes('en')) {
                changeLanguagePref(i18n, 'en-CA')
            } else if(i18n.language.includes('zh')) {
                changeLanguagePref(i18n, 'zh-CA')
            }
        }
    }, [])

    useEffect(() => {
        if(transferType !== '1') {
            setRouteId('');
            setRouteInfo({});
            setSelectedRoute({});
        } else {
            if(routeList?.length > 0) {
                setSelectedRoute(routeList[0]);
            }
        }
    }, [transferType])

    useEffect(() => {
        let curr = [{name: t('not_applicable'), id: '-1', total_dropoff: -1, storage_space: 0}];
        if(servicePointListCurr) {
            if(servicePointListCurr.length > 0) {
                let servicePointListCopy = JSON.parse(JSON.stringify(servicePointListCurr));
                servicePointListCopy.map((servicePoint) => {
                    curr.push(servicePoint);
                })
            }
        }
        setServicePointList(curr);
    }, [servicePointListCurr])

    useEffect(() => {
        if(openTransferOrdersDialog) {
            dispatch(getServicePoint(userPref.userCity));
            if(userUS) {
               dispatch(getRoutePlanners({
                    planner_name: '',
                    batch_info: selectedBatchIds.toString(),
                    service_number: currentDriverId
                }))
                .then((res) => {
                    setRouteList(res);
                    if(res?.length > 0) {
                        setSelectedRoute(res[0]);
                    }
                    setTransferType(res?.length > 0 ? '1' : '0');
                })
            }
            setShippingStatusNum(0);
            setServicePointId('');
            setRouteId('');
        }
    }, [openTransferOrdersDialog])

    useEffect(() => {
        window.localStorage.setItem('weight-status-filter', weightFilterTotal ? 1 : 0);
    }, [weightFilterTotal])


    const packIdStrModify = (orders) => {
        let sameAddressClone = [];
        let normalClone = [];
        if(orders?.sameAddress?.length > 0) {
            sameAddressClone = orders?.sameAddress.map((orderGroup) => {
                return orderGroup.map((order) => {
                    return Object.assign({ pack_id_str: order.pack_id > 0 ? order.pack_id + '' : "" }, order);
                })
            })
        }
        if(orders?.normal?.length > 0) {
            normalClone = orders?.normal.map((order) => {
                return Object.assign({ pack_id_str: order.pack_id > 0 ? order.pack_id + '' : "" }, order);
            })
        }
        if(mapMode === MapModes.ASSIGN_ROUTE) {
            sameAddressClone.forEach((order) => {
                order['pack_id_str'] = order.pack_id > 0 ? order['pack_id'] + '' : ""
            })
            normalClone.forEach((order) => {
                order['pack_id_str'] = order.pack_id > 0 ? order['pack_id'] + '' : ""
            })
        }
        setOrderMarkers({
            sameAddress: sameAddressClone,
            normal: normalClone
        })
    }

    const onMapModeChange = useCallback(
        newMapMode => {
            setMapMode(newMapMode)
        }
    )

    const handleEditOrderModalClose = useCallback((orderId, isUpdated)=>{
        //Order has been updated, it needs to refresh other areas of the app to reflect this change
        if(isUpdated){
            refreshExistOrders(dispatch, mapManagement.ordersByDriver, orderId, selectedBatchIds)
        }
    }, [mapManagement.ordersByDriver, selectedBatchIds])

    return (
        <div style={{width:'100vw', height: '100vh'}}>
            <HideablePanel
            id='leftPanel'
            containerStyle={classes.leftPanel} 
            position='left'
            tabs={menuTabs}
            >
                {menuTabs.map((tab, index)=>(
                    <ToolbarMenu 
                        key={`menuTab-${index}`}
                        config={tab.config}
                    />
                ))}
            </HideablePanel>
            <HideablePanel
            id='rightPanel'
            containerStyle={classes.rightPanel} 
            position='right'
            tabs={workTabs}
            disabled={!_.isEmpty(rightPanelDisable)}
            disableMessage={rightPanelDisable.message}
            isContentLoading={mapManagement.staffLoading}
            headerComponent={
                <HideablePanelHeader>
                    <BatchInfo 
                        selectedBatchIds={selectedBatchIds}
                        batchInfo={mapManagement.batchInfo}
                    />
                    <DriverSearch
                        handleWeightFilterTotal={handleWeightFilterTotal}
                        onKeywordChange={delaySearch}
                        onRefreshClicked={handleMainListRefresh}
                        handleReset={handleReset}
                    />
                </HideablePanelHeader>}
            >
                {mapManagement.staffError ? <ListError />: workTabs.map((tab, index) => {
                    return (
                        <AccountList
                            transferType={transferType}
                            routeInfo={routeInfo}
                            reset={reset}
                            handleAccountListDropOff={handleAccountListDropOff}
                            handleServicePointViewOpen={handleServicePointViewOpen}
                            servicePointViewOpen={servicePointViewOpen}
                            key={`accountList-${index}`}
                            weightFilterTotal={weightFilterTotal}
                            sectionLoading={mapManagement.ordersLoading}
                            orderList={mapManagement.ordersByDriver}
                            filter={orderFilters}
                            data={getAccountFilteredDistricts(_.filter(mapManagement.staff, function(staff){
                                if(tab.value === 0 || tab.value === 1){
                                    if(staff.workingarea === tab.label)
                                        return staff.id.toString().match(new RegExp(accountSearchKeyword, 'i'))
                                } else if(tab.value === 2){
                                    if((staff.workingarea !== "A" && staff.workingarea !== "B") && staff.workingstatus === 1)
                                        return staff.id.toString().match(new RegExp(accountSearchKeyword, 'i'))
                                } else if(tab.value === 3){
                                    if((staff.workingarea !== "A" && staff.workingarea !== "B") && staff.workingstatus === 0)
                                    return staff.id.toString().match(new RegExp(accountSearchKeyword, 'i'))
                                }
                            }))}
                        />
                    )
                })}
            </HideablePanel>
            <MapView
                center={mapDefaultCenter}
                id="mapView"
                mapMode={mapMode}
                onMapModeChange={onMapModeChange}
                markerSelectionMode={markerSelectionMode}
                onClick={handleMapClick}
                onOverlayComplete={onMapOverlayComplete}
            >
                {orderMarkers?.normal?.map((order, index) => (
                    <div key={index}>
                        <Marker
                            id={`order-marker-${order.order_id}`}
                            onClick={()=>handleOrderIconClick(order.order_id)}
                            options={{
                                position: {
                                    lat: Number(order.lat),
                                    lng: Number(order.lng)
                                },
                                icon: {
                                    url: _.indexOf(mapOrderSelection, order.order_id) !== -1 ? 
                                    "./images/markers/marker_selected.png"
                                    :
                                    getMarkerIcon(order),
                                    labelOrigin: new window.google.maps.Point(16,18)
                                },
                                visible: orderMarkerVisibility,
                                label: order.pack_id_str
                            }}
                        />
                        <Marker
                            id={`order-marker-express-${order.order_id}`}
                            onClick={()=>handleOrderIconClick(order.order_id)}
                            options={{
                                position: {
                                    lat: Number(order.lat),
                                    lng: Number(order.lng)
                                },
                                icon: {
                                    url: _.indexOf(mapOrderSelection, order.order_id) !== -1 ? 
                                    "./images/markers/express_select.png" :
                                    "./images/markers/express.png"
                                },
                                visible: orderMarkerVisibility && (order.express_type === 1)
                            }}
                        />
                    </div>
                ))}
                {_.map(orderMarkers.sameAddress, function(orderGroup){
                    let order = orderGroup[0]
                    return (
                        <div key={order.order_id}>
                            <Marker 
                                id={`order-group-marker-${order.order_id}`}
                                onClick={()=>{
                                    order.order_id === openInfoWindow ? 
                                    setOpenInfoWindow(null)
                                    :
                                    setOpenInfoWindow(order.order_id)
                                }}
                                options={{
                                    position: {
                                        lat: Number(order.lat),
                                        lng: Number(order.lng)
                                    },
                                    icon: {
                                        url: sameAddressMarkerIcon(orderGroup)[0],
                                        labelOrigin: new window.google.maps.Point(16,18)
                                    },
                                    visible: orderMarkerVisibility,
                                    label: `M:${orderGroup.length.toString()}`
                                }}
                            >
                                {order && _.findIndex(orderGroup, {'order_id': openInfoWindow}) !== -1 ?
                                    <InfoWindow>
                                        <div className={classes.mapInfoWindow}>
                                            {orderGroup.map((order)=> (
                                                <div key={order.order_id} style={{display:'flex', flexDirection: 'row'}}>
                                                    <div>
                                                        <Checkbox
                                                            classes={{
                                                                root: checkBoxClasses.root,
                                                                checked: checkBoxClasses.checked
                                                            }}
                                                            onClick={()=>handleOrderIconClick(order.order_id)}
                                                            checked={mapOrderSelection.indexOf(order.order_id) !== -1}
                                                        />
                                                    </div>
                                                    <div style={order.express_type?{color:'green'}:{color:'black'}}>
                                                        <Typography>Pack ID: {order.pack_id || "N/A"}</Typography>
                                                        <Typography>{order.tno || order.order_sn || `ID: ${order.order_id}`}</Typography>
                                                        {
                                                            order.express_type &&
                                                            <Typography>Express</Typography>
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </InfoWindow>
                                    :
                                    null
                                }
                            </Marker>
                            <Marker
                                id={`order-group-marker-express-${order.order_id}`}
                                onClick={()=>{
                                    order.order_id === openInfoWindow ? 
                                    setOpenInfoWindow(null)
                                    :
                                    setOpenInfoWindow(order.order_id)
                                }}
                                options={{
                                    position: {
                                        lat: Number(order.lat),
                                        lng: Number(order.lng)
                                    },
                                    icon: {
                                        url: sameAddressMarkerIcon(orderGroup)[1]
                                    },
                                    visible: checkSameAddressExpress(orderMarkerVisibility, orderGroup)
                                }}
                            />
                        </div>
                    )
                })}
                {routeManagement.routePreview.routes.map((order, index)=>(
                    <div key={order.order_id}>
                        <Marker
                            options={{
                                position: {
                                    lat: Number(order.lat),
                                    lng: Number(order.lng)
                                },
                                icon: {
                                    url: getMarkerIcon(order),
                                    labelOrigin: new window.google.maps.Point(16,18)
                                },
                                visible: true,
                                label: `${order.pack_id}`
                            }}
                        />
                        <Marker
                            onClick={()=>handleOrderIconClick(order.order_id)}
                            options={{
                                position: {
                                    lat: Number(order.lat),
                                    lng: Number(order.lng)
                                },
                                icon: "./images/markers/express.png",
                                visible: order.express_type === 1
                            }}
                        />
                    </div>
                ))}
                {routePlanner.start ? 
                    <Marker
                        key={`planner-start`}
                        options={{
                            position: {
                                lat: routePlanner.start.lat,
                                lng: routePlanner.start.lng
                            },
                            icon: {
                                url: "./images/markers/marker.png",
                                labelOrigin: new window.google.maps.Point(16,18)
                            },
                            visible: openRouteToolbar,
                            label: 'S'
                        }}
                    />
                    :
                    null
                }
                {routePlanner.end ? 
                    <Marker
                        key={`planner-end`}
                        options={{
                            position: {
                                lat: routePlanner.end.lat,
                                lng: routePlanner.end.lng
                            },
                            icon: {
                                url: "./images/markers/marker.png",
                                labelOrigin: new window.google.maps.Point(16,18)
                            },
                            visible: openRouteToolbar,
                            label: 'Fin'
                        }}
                    />
                    :
                    null
                }
                {
                    (servicePointListCurr &&
                    servicePointListCurr.length > 0) ?
                    servicePointListCurr.map((servicePoint) => (
                        accountListDropOff === servicePoint.name ?
                        <Marker
                            options={{
                                position: {
                                    lat: servicePoint.lat,
                                    lng: servicePoint.lng
                                },
                                icon: {
                                    url: './images/markers/house_yellow.png'
                                },
                                visible: servicePointViewOpen,
                                title: `${servicePoint.name}`
                            }}
                        />
                        :
                        <Marker
                            options={{
                                position: {
                                    lat: servicePoint.lat,
                                    lng: servicePoint.lng
                                },
                                icon: {
                                    url: './images/markers/house_blue.png'
                                },
                                visible: servicePointViewOpen,
                                // label: {
                                //     text:`${servicePoint.name}`,
                                //     color: 'white'
                                // },
                                title: `${servicePoint.name}`
                            }}
                        />
                    )) :
                    null
                }
            </MapView>
            <SelectBatchModal handleReset={handleReset}/>
            <EditOrderModal
                onClose={(orderId, isUpdated)=>handleEditOrderModalClose(orderId, isUpdated)}
            />
            <EditDriverModal/>
            <ParcelReturnModal/>
            <RouteToolbarModal
                mapMode={mapMode}
                onMapModeChange={(mode)=>onMapModeChange(mode)}
            />
            <StorageScan/>
            <SecondDelivery/>
            <DriverPickup/>
            <HelpDesk/>
            <PodQualityManagement/>
            <UpdateToolbox/>
            <EtaDeliveryRateReport/>
            <ComplaintModal/>
            <QuickTransfer/>
            <SelfReturn/>
            <TransferOrdersSubBatch/>
            <HoldingPackagesManagement/>
            <DriverDispatch/>
            <ScanReport/>
            <UploadExcelModal/>
            <LastStateStatistics/>
            <PreAlertQuery/>
            <PostalCodesExportToolbar 
                enableExport={enableExport} 
                overlayEvent={overlayEvent} 
                closeOverlay={closeOverlay} 
                handleExportOpen={handleExportOpen}
                overlayType={overlayType}
                bounds={bounds}
                oPoint={oPoint}
                radius={radius}
            />
            <LocalDeliveryCountReport/>
            <UserAuthUpdate/>
            <UniDialog 
                title={t('dialog:save_routes_title')}
                message={t('dialog:save_routes_message')}
                open={openDriveNotePrefixDialog} 
                onClose={()=>{dispatch(handleDriveNotePrefixDialog(false))}}
                onFinish={mapMode === MapModes.ASSIGN_ROUTE ? handleManualRouting: handleSaveRouteToDriver}
                openFunction={()=>{
                    if(selectedAccounts.length <= 0){
                        dispatch(handleDriveNotePrefixDialog(false))
                        return
                    }

                    let account = _.find(mapManagement.staff, ['id', selectedAccounts[0]])
                    if(account.length <= 0){
                        dispatch(handleDriveNotePrefixDialog(false))
                        return
                    }
                    setRoutePrefix(getRoutePrefix(stripIdFromStaffName(account.name)))
                }}
            >
                <TextField 
                    autoFocus
                    label="Prefix"
                    fullWidth
                    onChange={(e) => setRoutePrefix(e.target.value)}
                    value={routePrefix}
                />
            </UniDialog>
            <UniDialog
                title={t('dialog:transfer_orders_title')}
                message={t('dialog:transfer_orders_message')}
                open={openTransferOrdersDialog}
                onClose={()=> {
                    dispatch(setSelectedOrders([]));
                    dispatch(handleTransferOrdersDialog(false))
                    setTransferToId('');
                    setTransferDriverName('...');
                }
                }
                onFinish={handleTransferOrder}
                buttonDisabled={!transferToId || !servicePointId || !transferDriverName || transferDriverName === '...'}
                maxwidth='md'
                fullWidth
                draggable={true}
            >
                <div className={classes.driverStyle}>
                    <div style={{ marginBottom: 30 }}>
                        <span style={{ marginLeft: 10 }}>{transferDriverName}</span>
                    </div>
                    <div style={{ marginBottom: 30 }}>
                        <span>{t('package_num')}{shippingStatusNum}</span>
                    </div>
                    {
                        userUS &&
                        routeList?.length > 0 &&
                        <FormControl style={{ marginBottom: 30 }}>
                            <RadioGroup 
                                row
                                value={transferType}
                                onChange={(e)=>{setTransferType(e.target.value)}} 
                            >
                                <FormControlLabel value='0' control={<Radio/>} label={t('transfer_by_orders')} disabled={routeId}/>
                                <FormControlLabel value='1' control={<Radio/>} label={t('transfer_by_route')} disabled={routeList?.length<=0}/>
                            </RadioGroup>
                        </FormControl>
                    }
                    {
                        transferType === '1' &&
                        routeList?.length > 0 &&
                        <TextField
                            label="Assign Routes"
                            select
                            value={selectedRoute}
                            onChange={(event) => {
                                setSelectedRoute(event.target.value);
                            }}
                            variant="outlined"
                            fullWidth
                            style={{ marginBottom: 30 }}
                        >
                        {
                            routeList.map((route) => (
                                <MenuItem key={route.id} value={route}>
                                    {route.route_name}
                                </MenuItem>
                            ))
                        }
                        </TextField>
                    }
                    {
                        transferType === '1' &&
                        routeList?.length > 0 &&
                        <TextField
                            label="View Routes - Optional"
                            select
                            value={routeInfo.route_name}
                            onChange={(event) => {
                                setRouteId(event.target.value.id);
                                setRouteInfo(event.target.value.orders);
                            }}
                            variant="outlined"
                            fullWidth
                            style={{ marginBottom: 30 }}
                        >
                        {
                            routeList.map((route) => (
                                <MenuItem key={route.id} value={route}>
                                    {route.route_name}
                                </MenuItem>
                            ))
                        }
                        </TextField>
                    }
                    <TextField
                        autoFocus
                        label="Driver ID"
                        variant="outlined"
                        fullWidth
                        onChange={(e) =>
                        {
                            handleDynamicChangeMain(e.target.value);
                        }}
                        error={transferToId.length <= 0}
                    />
                    {
                        servicePointList &&
                        <Autocomplete
                            options={servicePointList}
                            getOptionLabel={(option) => option.name}
                            // getOptionDisabled={(option) => option.total_dropoff >= option.storage_space}
                            style={{ marginTop: 30 }}
                            fullWidth
                            renderInput={(params) => (
                                <TextField {...params} label={t("destined_drop_off")} variant="outlined" />
                            )}
                            onChange={(event, newValue) => {
                                if(!newValue) {
                                    setServicePointId('');
                                    return;
                                }
                                setServicePointId(newValue.id);
                            }}
                            renderOption={(option) => (
                                <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                                    <div>{option.name}</div>
                                    <div 
                                        style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: 300
                                        }}
                                    >
                                        {option.company}
                                    </div>
                                    {
                                        option.id !== '-1' &&
                                        <div>{option.total_dropoff}/{option.storage_space}</div>
                                    }
                                </div>
                            )}
                        />
                    }
                    <div style={{fontSize: 13, color: '#fff', marginTop: 6}}>
                        {t('last_location') + lastDropOff}
                    </div>
                </div>
            </UniDialog>
            <LoadDispatchHistoryModal 
                dispatchHistoryList={mapManagement.dispatchHistory}
                isLoading={mapManagement.dispatchHistoryLoading}
            />
            <UniDialog
                title={t('dialog:save_dispatch_history_title')}
                message={t('dialog:save_dispatch_history_message')}
                fullWidth
                open={openSaveDispatchHistoryDialog}
                onClose={()=>dispatch(handleSaveDispatchHistoryDialog(false))}
                onFinish={handleSaveDispatchHistory}
            >
                <TextField
                    autoFocus
                    label="Dispatch History Name"
                    fullWidth
                    onBlur={(e)=> setDispatchHistoryName(e.target.value)}
                />
            </UniDialog>
            <UniDialog
                title={t("dialog:order_filter_title")}
                fullWidth
                maxWidth='sm'
                open={openOrderFilterDialog}
                onClose={()=>dispatch(handleOrderFilterDialog({open: false}))}
                buttons={[{
                    color: 'primary',
                    text: t('common:reset'),
                    action: ()=> dispatch(resetOrderFilter(orderFilterTargetDriverId))
                }]}
            >
                <OrderFilter
                    pathCodes={getDriverOrderTrackingStatus(mapManagement.ordersByDriver[orderFilterTargetDriverId])}
                    filter={_.find(orderFilters, {'driverId': orderFilterTargetDriverId})}
                    handleParcelFilterChange={
                        (filter)=> {
                            dispatch(
                                changeParcelStatusFilter({
                                    driverId: orderFilterTargetDriverId, 
                                    ...filter
                                })
                            )
                        }
                        
                    }
                />
            </UniDialog>
            <UniDialog
                title="Problematic Orders"
                message="These orders have problems with Lat/Lng"
                fullWidth
                maxWidth='md'
                open={openDestinationEditDialog}
            >
                <ProblematicOrderList 
                    orderList={problemOrders}
                />
            </UniDialog>
            {selectedOrders.length > 0 ?
                <OrderSelectCounter
                    mapMode={mapMode}
                    count={selectedOrders.length}
                    mapSelectionCount={mapOrderSelection.length}
                    onMapSelectionClear={handleMapSelectionClear}
                    onMapSelection={handleMapSelectionConfirm}
                    onMapAssignFullClear={handleMapAssignFullClear}
                    onMapModeReset={handleMapModeReset}
                    onMapModeChange={onMapModeChange}
                    onManualRoutingConfirm={()=>dispatch(handleDriveNotePrefixDialog(true))}
                    selectedWeight={selectedWeight}
                />
                :
                null
            }
            <DestinationEditModal 
                open={openDestinationEditDialog}
                selectedBatchIds={selectedBatchIds}
                order={editOrder}
                onClose={()=>{dispatch(handleOpenDestinationEditDialog({open:false}))}}
            />
            <MapToolBar
                mode={markerSelectionMode}
                markerSelectionModeChange={(mode)=>dispatch(setMarkerSelectionMode(mode))}
                enableCircle={enableCircle}
            />
            <AdvancedSearchModal />
            <WorkflowModal />
            <SettingsModal />
            <MessageCenter />
            <BbcOrderManagement />
            <FullscreenLoading open={mapManagement.loading || routeManagement.loading}/>
        </div>
    )
    
    function handleAccountListDropOff(value) {
        setAccountListDropOff(value);
    }

    function handleServicePointViewOpen(viewOpen) {
        setServicePointViewOpen(viewOpen);
    }

    function handleReset(reset) {
        setReset(reset);
    }

    function handleWeightFilterTotal(filterTotal) {
        setWeightFilterTotal(filterTotal);
    }

    function handleExportOpen(isOpen) {
        setEnableCircle(isOpen)
    }

    function handleDynamicChangeMain(driverId) {
        let name = handleTextualizeDriverNameAndVehicleType(driverId, userPref.userCity, driverListTemp, searchList);
        setTransferDriverName(name);
        
        if(name === '...') {
            setDriverExist(false);
            setShippingStatusNum(0);
        } else {
            dispatch(getDriverServicePoint(driverId))
            .then((res) => {
                setLastDropOff(res.name);
            })
            .catch((err) => {
                setLastDropOff(t('not_set_yet'));
            })
            dispatch(getDriverOrdersByShippingStatus(driverId))
            .then((res) => {
                setShippingStatusNum(res.shipping_status_1);
                setShippingStatusNum0(res.shipping_status_0);
            })
        }
        setTransferToId(driverId);
    }

    async function handleTransferOrder(){
        if (transferToId.length <= 0){
            dispatch(showAlertSnackbar({title: "Transfer to driver ID cannot be empty"}))
            return
        }

        if(transferType === '1' && routeId) {
            selectedOrders = _.map(routeInfo, 'order_id');
        }

        let assignParams = {
            orders: selectedOrders,
            to_driver: transferToId,
            from_driver: currentDriverId,
            operator: userPref.username,
            planner_id: transferType !== '1' ? null : (selectedRoute?.id || null),
            batch_info: selectedBatchIds?.toString() || ''
        }
        
        if (selectedOrders.length <= 0){
            dispatch(showAlertSnackbar({title: "Please select orders for transfer"}))
            return
        }

        try {
            await dispatch(assignServicePoint(transferToId, servicePointId))
            await dispatch(assignOrderToDriver(assignParams))
            await dispatch(getDriverOrderCount(userPref.userCity, selectedBatchIds, userPref.hideAssociatedOrders, userPref.hideSubReferrer))
            dispatch(getDriverOrders(transferToId, selectedBatchIds, userPref.hideAssociatedOrders, userPref.hideSubReferrer, userPref.userCity))
            _.forEach(selectedAccounts, (account) => {
                dispatch(getDriverOrders(account, selectedBatchIds, userPref.hideAssociatedOrders, userPref.hideSubReferrer, userPref.userCity))
            })
            dispatch(resetSelectedOrders())
            dispatch(resetSelectedAccounts())
            dispatch(resetOrderMarker());
            handleMainListRefresh();
        }catch(error){
            dispatch(showAlertSnackbar({title: "Transfer Order", message: error.message}))
        }
    }

    async function handleSaveRouteToDriver(){
        let routesPreview = routeManagement.routePreview;
        try{
            if (routesPreview.routes.length <= 0){
                let orders = getCheckedOrders(mapManagement.ordersByDriver, selectedOrders)
                let reduced = _.map(orders, _.partialRight(_.pick, ['order_id', 'lat', 'lng']))
                if(reduced.length > 500 && routeType === 3) {
                    await dispatch(showAlertSnackbar({message: t('hopper_not_support'), type: 'error'}));
                    return;
                }
                routesPreview = await rmHelper.handleRoutePlanning(t, dispatch, reduced, userPref.userCity, routeType, routePlanner);
            }
        } catch(error){
            dispatch(showAlertSnackbar({title: "Unable to calculate route data", message: error.message}))
            return;
        }
        try {
            let reducedPreview = _.map(routesPreview.routes, _.partialRight(_.pick, ['order_id', 'pack_id', 'lat', 'lng','distance']))
            let distance = routeType === 2 ? routesPreview.distance * 1000 : routesPreview.distance;
            let duration = routeType === 2 ? routesPreview.duration * 60 : routesPreview.duration;
            let saveRoutesParams = {
                orders: reducedPreview,
                driver_notes: `${routePrefix}-`,
                batch_info: selectedBatchIds.toString(),
                service_number: currentDriverId,
                distance: distance.toFixed(2),
                duration: duration.toFixed(2),
                planner_type: routeType
            }
            await dispatch(saveRoutes(saveRoutesParams))
            await dispatch(getDriverOrderCount(userPref.userCity, selectedBatchIds, userPref.hideAssociatedOrders, userPref.hideSubReferrer))
            //This normally should only run once, but just incase for later adjustments there is a for loop
            _.forEach(selectedAccounts, (account) => {
                dispatch(getDriverOrders(account, selectedBatchIds, userPref.hideAssociatedOrders, userPref.hideSubReferrer, userPref.userCity))
            })
            dispatch(resetOrderMarker())
            handleCloseRoutePlanner()
        } catch(error) {
            dispatch(showAlertSnackbar({title: "Unable to save routes", message: error.message}))
        }
    }

    function handleSaveDispatchHistory(){
        if(dispatchHistoryName.length <= 0 || selectedBatchIds.length <= 0){
            dispatch(showAlertSnackbar({title: "Unable to create dispatch history", message: "Dispatch group name cannot be empty!"}))
            return
        }
        dispatch(createDispatchHistory(userPref.userCity, userPref.username, dispatchHistoryName.trim(), selectedBatchIds)).catch(error => {
            dispatch(showAlertSnackbar({title: "Unable to create dispatch history", message: error.message}))
        })
    }

    function closeOverlay(event) {
        setEnableExport(false);
        if(event) {
            if(event.overlay) {
                event.overlay.setMap(null)
            }
        }
    }

    function onMapOverlayComplete(event){
        if(openPostalCodesToolbar) {
            setOverlayEvent(event);
            if(event.type === window.google.maps.drawing.OverlayType.POLYGON) {
                setOverlayType(1);
                let bounds = [];
                let sd = event.overlay.latLngs.Ed[0].Ed;
                sd.map((position) => {
                    bounds.push([position.lat(), position.lng()])
                })
                // _.forEach(sd, (group)=>{
                //     group.sd.map((position) => {
                //         bounds.push([position.lat(), position.lng()]);
                //     })
                // })
                if(bounds.length >= 3) {
                    setEnableExport(true);
                } else {
                    setEnableExport(false);
                } 
                setBounds(bounds);
                return; 
            } else if(event.type === window.google.maps.drawing.OverlayType.CIRCLE) {
                setOverlayType(2);
                let center = event.overlay.center;
                let centerLat = center.lat();
                let centerLng = center.lng();
                let radius = event.overlay.radius;
                if(radius > 0 && center && centerLat && centerLng) {
                    setRadius(radius);
                    setOPoint([centerLat, centerLng]);
                    setEnableExport(true);
                } else {
                    setEnableExport(false);
                }
                return;
            } else {
                event.overlay.setMap(null)
                return;
            }
        }

        let markers = orderMarkers.normal
        _.forEach(orderMarkers.sameAddress, (group)=>{
            markers = [...markers, ...group]
        })
        let orderIds = _.compact(_.map(markers, function(order){
            let point = new window.google.maps.LatLng(order.lat, order.lng)
            if (event.type === window.google.maps.drawing.OverlayType.POLYGON){
                if(window.google.maps.geometry.poly.containsLocation(point, event.overlay)) {
                    return order.order_id
                }
            } else if (event.type === window.google.maps.drawing.OverlayType.RECTANGLE){
                let rectangle = event.overlay
                if(rectangle.getBounds().contains(point)) {
                    return order.order_id
                }
            }
        }))
        if(orderIds.length > 0) {
            let removeIds = _.intersection(mapOrderSelection, orderIds)
            let addIds = _.difference(orderIds, removeIds)
            if(removeIds.length > 0){
                setMapOrderSelection(_.difference(mapOrderSelection, removeIds))
            }
            if(addIds.length > 0){
                setMapOrderSelection(_.union(mapOrderSelection, addIds))
            }    
        }
        event.overlay.setMap(null)
    }

    function handleMapClick(event){
        let lat = event.latLng.lat()
        let lng = event.latLng.lng()

        if(mapMode === MapModes.SELECT_START){
            dispatch(setRouteStartPoint({lat, lng}))
            setMapMode(MapModes.SELECT_END)
        } else if(mapMode === MapModes.SELECT_END){
            dispatch(setRouteEndPoint({lat, lng}))
            setMapMode(MapModes.SELECT_MARKER)
        }
    }

    function handleCloseRoutePlanner(){
        dispatch(handleRouteToolbar(false))
        dispatch(resetRoutePreview())
        dispatch(showOrderMarkerVisibility())
    }

    function handleMainListRefresh(){
        dispatch(resetSelectedOrders())
        batchChange(
            dispatch, 
            userPref.userCity, 
            selectedBatchIds, 
            batchSelectionConfig.isHideAssociated,
            batchSelectionConfig.isHideSubReferrer
        )
    }

    //#region Handle Map Clicking
    function handleOrderIconClick(id){
        switch(mapMode){
            case MapModes.SELECT_MARKER:
                selectMarkerOrder(id)
                break;
            case MapModes.ASSIGN_ROUTE:
                assignRouteToMarker(id)
                break;
            default: break;
        }
    }

    function handleMapModeReset(){
        setMapMode(MapModes.SELECT_MARKER)
        handleMapSelectionClear()
    }

    function handleMapSelectionClear(){
        if(unmodifiedOrderMarker.current !== null){
            packIdStrModify(unmodifiedOrderMarker.current)
            unmodifiedOrderMarker.current = null
        }
        setMapOrderSelection([])
    }

    //assigns empty pack_id to all markers
    function handleMapAssignFullClear(){
        setUnmodifiedOrderMarker()
        let cloneOrders = orderMarkers
        _.forEach(cloneOrders.normal, (order, index) => {
            cloneOrders = getUpdatedNormalAddressOrders(cloneOrders, index, 0)
        })
        _.forEach(cloneOrders.sameAddress, (group, groupIndex) => {
            _.forEach(group, (order, index) => {
                cloneOrders = getUpdatedSameAddressOrders(cloneOrders, groupIndex, index, 0)
            })
        })
        packIdStrModify(cloneOrders)
    }

    function selectMarkerOrder(id){
        let array = [...mapOrderSelection]
        let index = _.indexOf(mapOrderSelection, id)
        if(index !== -1){
            array.splice(index, 1)
            setMapOrderSelection(array)
        } else {
            setMapOrderSelection([...mapOrderSelection, id])
            dispatch(scrollToOrderId(id))
        }
    }

    function setUnmodifiedOrderMarker(){
        if(unmodifiedOrderMarker.current === null){
            unmodifiedOrderMarker.current = orderMarkers
        }
    }

    function assignRouteToMarker(id){
        let foundOrder = _.findIndex(orderMarkers.normal, {'order_id': id})
        let orderList = getFlattenOrderList()
        let orderIndex = _.findIndex(orderList, {'order_id': id})
        setUnmodifiedOrderMarker()
        
        //Check with same address
        let orderSameAddressIndex = getSameAddressOrderIndex(id)
        //not in both lists, something is wrong so jump out of func
        //Can throw errors later on
        if(orderIndex === -1) return
        else {
            //remove all pack_id when clicked
            if(orderSameAddressIndex !== -1){
                let isAnyPackIdSet = false
                isAnyPackIdSet = _.some(orderMarkers.sameAddress[orderSameAddressIndex], (order) => {
                    return order.pack_id > 0
                })
                if(isAnyPackIdSet){
                    updateMarkerPackId(orderMarkers, 'sameAddress', orderSameAddressIndex, foundOrder, 0)
                    return
                }
            } else if(foundOrder !== -1 && orderMarkers.normal[foundOrder].pack_id !== 0){
                updateMarkerPackId(orderMarkers, 'normal', orderSameAddressIndex , foundOrder, 0)
                return
            }
        }

        let packIdList = getPackIdList(orderList)
        let nextPackId = getNextPackId(packIdList)

        if(orderSameAddressIndex !== -1){
            let cloneOrders = orderMarkers
            _.forEach(cloneOrders.sameAddress[orderSameAddressIndex], (order, index) => {
                cloneOrders = getUpdatedSameAddressOrders(cloneOrders, orderSameAddressIndex, index, nextPackId)
                nextPackId++
            })
            let updatedPackIds = _.map(cloneOrders.sameAddress[orderSameAddressIndex], (o, index)=>{
                return nextPackId + index
            })
            let duplicatedPackIds = _.intersection(updatedPackIds, packIdList)
            if(duplicatedPackIds.length > 0){
                let largestPackId = _.max(duplicatedPackIds)
                _.forEach(cloneOrders.normal, (order, index)=>{
                    if(order.pack_id && order.pack_id >= largestPackId){
                        largestPackId++
                        //cloneOrders = update(cloneOrders, {'normal': {[index]: {pack_id: {$set: largestPackId}}}})
                        cloneOrders = getUpdatedNormalAddressOrders(cloneOrders, index, largestPackId)
                    }
                })
                _.forEach(cloneOrders.sameAddress, (orders, sameAddressIndex) => {
                    _.forEach(orders, (order, index) => {
                        if(order.pack_id && order.pack_id >= largestPackId){
                            if(sameAddressIndex !== orderSameAddressIndex){
                                largestPackId++
                                cloneOrders = getUpdatedSameAddressOrders(cloneOrders, sameAddressIndex, index, largestPackId)
                            }
                        }
                    })
                })
            }
            packIdStrModify(cloneOrders)
        } else if(orderIndex !== -1){
            updateMarkerPackId(orderMarkers, 'normal', orderSameAddressIndex, foundOrder, nextPackId)
        }

        function getSameAddressOrderIndex(id){
            let result = -1
            _.some(orderMarkers.sameAddress, (orders, locationIndex)=>{
                let index = _.findIndex(orders, {'order_id': id})
                if(index !== -1) {
                    result = locationIndex
                    //This allows for a loop break
                    return true
                }
            })
            return result
        }

        function getFlattenOrderList(){
            let normalList = []
            let sameAddressList = []
            if(orderMarkers.normal.length > 0){
                normalList = orderMarkers.normal
            }
            if(orderMarkers.sameAddress.length > 0){
                sameAddressList = _.flatten(orderMarkers.sameAddress)
            }
            return _.union(normalList, sameAddressList)
        }

        function getNextPackId(packIdList){
            let result = 0
            let isFinished = false
            for(let i = 0; i < packIdList.length; i++){
                if(packIdList[i] - packIdList[i-1] != 1 && !isNaN(packIdList[i] - packIdList[i-1])){
                    result = packIdList[i-1] + 1
                    isFinished = true
                    break;
                }
            }
            if(!isFinished){
                result = _.last(packIdList) + 1
            }
            return result
        }

        function getPackIdList(orderList){
            let result = []

            _.forEach(orderList, (order)=>{
                result.push(order.pack_id || 0)
            })

            return _.sortBy(_.uniq(result))
        }

        function updateMarkerPackId(markerArray, type, sameAddressIndex = -1, orderIndex, setPackId){
            let cloneOrders
            if(sameAddressIndex === -1){
                cloneOrders = update(markerArray, {[type]: {[orderIndex]: {pack_id: {$set: setPackId}}}})
            } else {
                cloneOrders = markerArray
                _.forEach(markerArray.sameAddress[sameAddressIndex], (order, index) => {
                    cloneOrders = update(
                        cloneOrders, {
                            [type]: {
                                [sameAddressIndex]: {
                                    [index]: {
                                        pack_id: {
                                            $set: order.pack_id > 0 && setPackId <= 0 ? setPackId: setPackId + index
                                        }
                                    }
                                }
                            }
                        }
                    )
                })
            }
            packIdStrModify(cloneOrders)
        }
    }

    function getUpdatedNormalAddressOrders(orders, index, packId){
        return update(
            orders, {'normal': {[index]: {pack_id: {$set: packId}}}}
        )
    }

    function getUpdatedSameAddressOrders(orders, parentIndex, index, nextPackId){
        return update(
            orders, {
                'sameAddress': {
                    [parentIndex]: {
                        [index]: {
                            pack_id: {
                                $set: nextPackId
                            }
                        }
                    }
                }
            }
        )
    }

    async function handleManualRouting(){
        if(unmodifiedOrderMarker.current === null){
            dispatch(showAlertSnackbar({
                title: "Manual Routing", 
                message: "Nothing has changed! Not updating anything!",
                duration: 5000
            }))
            return
        }

        let modifiedCombinedOrders = _.union(orderMarkers.normal, _.flatten(orderMarkers.sameAddress))
        let unmodifiedCombinedOrders = _.union(unmodifiedOrderMarker.current.normal, _.flatten(unmodifiedOrderMarker.current.sameAddress))

        let differences = _.differenceWith(modifiedCombinedOrders, unmodifiedCombinedOrders, _.isEqual)
        if(differences.length <= 0){
            dispatch(showAlertSnackbar({
                title: "Manual Routing", 
                message: "Nothing has changed! Not updating anything!",
                duration: 5000
            }))
            return
        }

        let updateArray = _.map(differences, _.partialRight(_.pick, ['order_id', 'pack_id', 'lat', 'lng','distance']))
        let saveRoutesParams = {
            orders: updateArray,
            driver_notes: `${routePrefix}-`,
            batch_info: selectedBatchIds.toString(),
            service_number: currentDriverId,
            distance: routeManagement.routePreview.distance,
            duration: routeManagement.routePreview.duration
        }
        try{
            let account = _.find(mapManagement.staff, ['id', selectedAccounts[0]])
            
            await dispatch(saveRoutes(saveRoutesParams))
            await dispatch(getDriverOrderCount(userPref.userCity, selectedBatchIds, userPref.hideAssociatedOrders, userPref.hideSubReferrer))
            //This normally should only run once, but just incase for later adjustments there is a for loop
            _.forEach(selectedAccounts, (account) => {
                dispatch(getDriverOrders(account, selectedBatchIds, userPref.hideAssociatedOrders, userPref.hideSubReferrer,userPref.userCity))
            })
            unmodifiedOrderMarker.current = null
            dispatch(resetOrderMarker())
            handleMapModeReset()
        } catch(error){
            dispatch(showAlertSnackbar({title: "Unable to save routes", message: error.message}))
        }
    }

    function handleMapSelectionConfirm(){
        let orderIds = mapOrderSelection
        let removeIds = _.difference(selectedOrders, orderIds)
        dispatch(removeMarker(removeIds))
        dispatch(setSelectedOrders(orderIds))
        //setMapMode(MapModes.NONE)
        setMapOrderSelection([])
    }

    function generateOrderMapMarker(orders, listOfIds){
        let normal = [], sameAddress = []
        if(_.isEmpty(orders) || listOfIds.length <= 0)
            return {normal, sameAddress}
        let orderList = flattenOrders(orders)
        let filteredOrderList = _.chain(orderList).keyBy('order_id').at(listOfIds).value()

        //If too slow, change this to a more effecient one
        filteredOrderList.forEach((order)=>{
            if(order) {
               let group = _.filter(filteredOrderList, {'lat': order.lat, 'lng': order.lng})
                if(group.length > 1){
                    sameAddress.push([...group])
                    _.pullAll(filteredOrderList, group)
                } 
            }
        })
        normal = _.compact(filteredOrderList)
        return {
            normal,
            sameAddress
        }
    }

    function checkSameAddressExpress(orderMarkerVisibility, orderGroup=[]) {
        let expressExist = false;
        orderGroup.forEach(order => {
            if(order.express_type === 1) {
                expressExist = true;
                return; 
            }
        });
        return orderMarkerVisibility && expressExist;
    }

    function sameAddressMarkerIcon(orderGroup){
        let filtered = []
        _.forEach(orderGroup, (order)=>{
            _.forEach(mapOrderSelection, (id)=>{
                if(id === order.order_id){
                    filtered.push(1)
                }
            })
        })

        if(filtered.length === orderGroup.length){
            return [
                "./images/markers/marker_selected.png",
                "./images/markers/express_select.png"
            ]
        } else if(filtered.length > 0 && filtered.length < orderGroup.length){
            return [
                "./images/markers/marker_multi_partial_select.png",
                "./images/markers/express_select.png"
            ]
        } else {
            return [
                "./images/markers/marker_multi.png",
                "./images/markers/express.png"
            ]
        }
    }
    //#endregion

    function rightPanelLock(){
        let result = {}
        if(routeManagement.routePreview.routes.length > 0){
            result = {
                message: t('hint_lock_route_message')
            }
        }
        if(mapOrderSelection.length > 0){
            result = {
                message: t('hint_lock_map_selection_message')
            }
        }
        if(mapMode === MapModes.ASSIGN_ROUTE){
            result = {
                message: t('hint_lock_assign_route_message')
            }
        }
        return result
    }

    function getMarkerIcon(order){
        let totalWeight = Number(order.total_weight) || 0
        if(totalWeight >= 5 && totalWeight <= 10){
            //Medium parcel
            return "./images/markers/marker_light_green.png"
        } else if(totalWeight > 10 ){
            //Large parcel
            return "./images/markers/marker_purple.png"
        } else {
            return "./images/markers/marker.png"
        }
    }
}

export default Main
